export default {
	primary: '#ffcc01'
}


// WEBPACK FOOTER //
// ./src/themes/vividyellowTheme.js